//localization form mobile
document.querySelectorAll('.currency-disclosure-item-link-mobile').forEach(item => {
    item.addEventListener('click', function(event) {
      event.preventDefault();
      const value = this.getAttribute('data-value');
      const selectElement = document.querySelector('select[name="currency"]');
      selectElement.value = value;
      document.querySelector('.currency-disclosure-button-mobile').textContent = value;
      selectElement.dispatchEvent(new Event('change'));
    });
  });
  
  class LocalizationFormMobile extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('language-panel'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  
      // Hinzufügen eines Event-Listeners für Klicks außerhalb des Dropdowns
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.style.display = 'none';
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.panel.style.display = this.elements.panel.hasAttribute('hidden') ? 'none' : 'block';
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  
    // Überarbeitete Methode zum Schließen des Dropdowns bei Klick außerhalb
    onDocumentClick(event) {
      if (!this.contains(event.target) && !this.elements.button.contains(event.target)) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('localization-form-mobile', LocalizationFormMobile);
  //localization currency mobile
  class CurrencyFormMobile extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="currency"]'),
        button: this.querySelector('.currency-disclosure-button-mobile'),
        panel: this.querySelector('.currency-disclosure-list-mobile'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('.currency-disclosure-item-link-mobile').forEach(item => {
        item.addEventListener('click', function(event) {
          event.preventDefault();
          const value = this.getAttribute('data-value');
          document.querySelector('select[name="currency"]').value = value;
          document.querySelector('.currency-disclosure-button-mobile').textContent = value;
        });
      });
  
      // Hinzufügen eines Event-Listeners für Klicks außerhalb des Dropdowns
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.style.display = 'none';
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.panel.style.display = this.elements.panel.hasAttribute('hidden') ? 'none' : 'flex';
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  
    // Überarbeitete Methode zum Schließen des Dropdowns bei Klick außerhalb
    onDocumentClick(event) {
      if (!this.contains(event.target) && !this.elements.button.contains(event.target)) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('currency-form-mobile', CurrencyFormMobile);
  // localisation form 
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }
  
  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });
  
  document.querySelectorAll('.currency-disclosure-item-link').forEach(item => {
    item.addEventListener('click', function(event) {
      event.preventDefault();
      const value = this.getAttribute('data-value');
      const selectElement = document.querySelector('select[name="currency"]');
      selectElement.value = value;
      document.querySelector('.currency-disclosure-button').textContent = value;
      selectElement.dispatchEvent(new Event('change'));
    });
  });
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('language-panel'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  
      // Hinzufügen eines Event-Listeners für Klicks außerhalb des Dropdowns
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.style.display = 'none';
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.panel.style.display = this.elements.panel.hasAttribute('hidden') ? 'none' : 'block';
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  
    // Überarbeitete Methode zum Schließen des Dropdowns bei Klick außerhalb
    onDocumentClick(event) {
      if (!this.contains(event.target) && !this.elements.button.contains(event.target)) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('localization-form', LocalizationForm);
  //currency form 
  class CurrencyForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="currency"]'),
        button: this.querySelector('.currency-disclosure-button'),
        panel: this.querySelector('.currency-disclosure-list'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('.currency-disclosure-item-link').forEach(item => {
        item.addEventListener('click', function(event) {
          event.preventDefault();
          const value = this.getAttribute('data-value');
          document.querySelector('select[name="currency"]').value = value;
          document.querySelector('.currency-disclosure-button').textContent = value;
        });
      });
  
      // Hinzufügen eines Event-Listeners für Klicks außerhalb des Dropdowns
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.style.display = 'none';
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.panel.style.display = this.elements.panel.hasAttribute('hidden') ? 'none' : 'block';
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  
    // Überarbeitete Methode zum Schließen des Dropdowns bei Klick außerhalb
    onDocumentClick(event) {
      if (!this.contains(event.target) && !this.elements.button.contains(event.target)) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('currency-form', CurrencyForm);
  